import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage', {
        url: '/manage/:directoryId',
        redirectTo: 'company.directory-integration.manage.main',
        component: 'companyDirectoryIntegrationManage',
        resolve: {
            $breadcrumbs,
            directory,
            directoryId,
        },
    });
}

/** @ngInject */
function $breadcrumbs(directory) {
    return [{title: directory.name}];
}

/** @ngInject */
function directory(companyId, DirectoriesResource, directoryId) {
    return DirectoriesResource.getDirectory(companyId, directoryId)
        // .then((directory) => ({...directory, agentConnected: 'ACTIVE'}))
}

/** @ngInject */
function directoryId($stateParams) {
    return $stateParams.directoryId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/directory-manage.state.js